/**
 * The shared filterable list (decision 101, #401): what a list can be filtered by.
 *
 * A field has one value at a time, which is what every list read in the console accepts today
 * (`?status=pending`). Finite options carry the label the person reads; the value goes in the URL.
 * A monthPicker field passes `options: []` and selects a month/year without finite options.
 */
export interface FilterOption {
  readonly value: string;
  readonly label: string;
}

export interface FilterField {
  /** The URL parameter, e.g. `status`. */
  readonly key: string;
  /** What the field is called on screen, e.g. «Stato». */
  readonly label: string;
  readonly options: readonly FilterOption[];
  /** A persistent month/year picker instead of finite options. */
  readonly monthPicker?: boolean;
}

/** The label of the value a field holds, or the raw value when no option matches it. */
export function optionLabel(field: FilterField, value: string): string {
  return field.options.find((option) => option.value === value)?.label ?? value;
}
